import { create } from 'zustand';

/**
 * Modo concentración: mientras juegas una partida en el móvil se esconde la
 * barra de pestañas de abajo, para ganar tablero y no salir de la partida
 * por un toque sin querer.
 */
export const useFocusMode = create<{ playing: boolean; setPlaying: (playing: boolean) => void }>((set) => ({
  playing: false,
  setPlaying: (playing) => set({ playing }),
}));
